import { useEffect } from "react";
import { usePatchPropertyFlatMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPropertyFlatMutation";
import type { ClientPropertyFlatDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getFlatFormSchema } from "web_myplann/Portfolio/Forms/FlatForm/flatFormSchema";
import { mapPropertyToFlatForm } from "web_myplann/Portfolio/Forms/FlatForm/mapPropertyToFlatForm";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditFlatFormArgs = {
	propertyId: number;
	property: ClientPropertyFlatDetailResponseDTO;
	detailRoute: string;
};

export const useEditFlatForm = ({
	propertyId,
	property,
	detailRoute,
}: UseEditFlatFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } = usePatchPropertyFlatMutation(propertyId);

	const { form, onSubmit, leaveConfirmation } = useEditPortfolioForm({
		schema: getFlatFormSchema(t),
		defaultValues: mapPropertyToFlatForm(property),
		mutate,
		successToast: t(Resources.Portfolio.EditRealEstate.savedToast, {
			type: t(Resources.Portfolio.AddRealEstate.Types.Flat),
		}),
		redirectTo: detailRoute,
		isPending,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending, leaveConfirmation };
};
